import { getRequest } from '../services/requestHandler';
import { PutterLevel } from '../models';

export const getPutterLevels = async () => {
  const url = 'putter/getPutterLevels?activeOnly=true&useCache=false';
  const response = await getRequest<PutterLevel>('GetPutterLevels', url);
  return response;
};
